var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "componentTextPersona" }, [
      _c("i", { staticClass: "fa-solid fa-user-tie-hair" }),
      _c("p", { staticClass: "title-text-persona" }, [_vm._v("Profil type")]),
      _c("div", { staticClass: "genre" }, [
        _c("h3", [_vm._v("Femme")]),
        _c("i", { staticClass: "fa-solid fa-venus" })
      ]),
      _c("div", { staticClass: "age" }, [
        _c("p", [_vm._v("âgée de")]),
        _c("h3", [_vm._v("45-54 ans")])
      ]),
      _c("div", { staticClass: "country" }, [
        _c("p", [_vm._v("de")]),
        _c("h3", [_vm._v("France")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }